import * as angular from 'angular';

import {
  Input,
  OnInit,
  Inject,
  Component,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';

import summaryHtml from './summary.html';
import './summary.scss';



/**
 * Shopping Cart Summary
 *
 * Displayed on offcanvas panel
 * detailing cart order and pricing totals.
 */
@Component({
  selector: 'gwCartSummary',
  template: summaryHtml,
})
export class SummaryComponent implements OnInit {
  public cart = (<any>window).GW.cart;
  public laroute = (<any>window).laroute;
  public cartSummary;

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
  ) {}

  ngOnInit() {
    // Group order items by product
    this.cartSummary = this.$filter('groupBy')(this.cart.order, 'productId');
  }

  getTotalItems(): string {
    const items = this.cart.order.length;

    return `${items} ${items > 1 ? 'items' : 'item'}`;
  }

  getSubtotal(shipping: number, options, product): number {
    return this.cartService.getSubtotal(shipping, options, product.addons);
  }

  getGroupSubtotal(orderItems, productId: string): number {
    let subtotal = 0;

    orderItems.forEach((orderItem) => {
      let outbound = null;

      if (orderItem.type === 'visa') {
        outbound = this.cart.travelers[orderItem.travelerId].outbound.price;
      } else if (orderItem.type === 'passport') {
        outbound = orderItem.outbound.price;
      }

      subtotal += this.getSubtotal(
        outbound,
        this.cart.options[orderItem.optionsId],
        this.cart.products[productId],
      );
    });

    return subtotal;
  }

  total(): string {
    const total = this.cartService.getOrderTotal();
    return this.$filter('currency')(total);
  }

  getCartUrl(): string {
    return this.laroute.route('checkout.cart');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/summary/summary.component.ts